import React, { useState, useEffect } from 'react';
import SliderProductsContainer from 'containers/SliderProducts';
import PropTypes from 'prop-types';
import CMSFactory from "factories/CMS";
import style from './style.scss'; //NOSONAR

const DoubleShelfSlider = (props) => {
    const [tabs, setTabs] = useState([]);
    let dateServer = '';

    useEffect(() => {
        dateServer = props.date ? props.date : '';
        if(props.data){
            getTabs(props.data.shelf_slider);
        }
        
    }, []);

    const getTabs = (items) => {
        let counter = 0;
        if(!items) return [];
        
        items = items.map((data) => {
            if (counter > 1) return false;
            let serverDate = dateServer;
            let startDate = CMSFactory.milliseconds(data.start_date);
            let endDate = CMSFactory.milliseconds(data.end_date);
            if (startDate && (startDate >= serverDate)) return false; 
            if(endDate && (endDate <= serverDate)) return false;
            if (data.active != true) return false;
            counter++;
            data.visible = true;
            return data;
        }).filter(Boolean);

        setTabs(items);
    }
        
    const callbackSlider = (index, visible) => {
        tabs[index].visible = visible;

        setTabs(tabs);
    }

    let tabsArray = props.data ? tabs : [];
    let count = 0;
    if(!tabs.length) return '';

    return (
        <div className="home-container-slider-small" >
            <div className="limitator">
                {tabsArray.map((data, i) => {
                    if (count > 1) return false;
                    count++;
        
                    return (
                        <div className={"slider-small" + (data.visible ? ' show' : '')} key={count}>
                            <h4 className="new-slider-small-title">{data.title}</h4>
                            <SliderProductsContainer options={{ collections: 'H:' + data.id }}  callbackNotProducts={(visibility) => callbackSlider(i, visibility)}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
    
}

DoubleShelfSlider.propTypes = {
    data: PropTypes.object,
    date: PropTypes.number
}
export default DoubleShelfSlider;
